import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

export default function ProcurementReportPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/api/reports/procurement/work-orders-status');
        setData(res.data || []);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error loading procurement status', e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <p>Loading…</p>;

  return (
    <div className="container">
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <h3>Work Orders by Status</h3>
        <Link to="/reports/work-orders" className="eduss-global-table-btn">Open Work-Order Analytics</Link>
      </div>
      {/* Chart removed as per requirement */}
      <table className="table" style={{marginTop:24}}>
        <thead><tr><th>Status</th><th>Count</th></tr></thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}><td>{row.status}</td><td>{row.orders??row.count}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
